import { Injectable } from '@angular/core';
import { RxStomp } from '@stomp/rx-stomp';
import { BehaviorSubject, Subscription, tap } from 'rxjs';
import { AuthService } from '../auth/auth.service';

export type WsSubscriptionType = 'qna' | 'qnaChat' | '';

export const WsSubscriptionMap = new Map<WsSubscriptionType, Subscription>();

interface QnaheaderWsBody {
  id: number;
}

@Injectable({
  providedIn: 'root',
})
export class RxStompService extends RxStomp {
  qnaSubject = new BehaviorSubject<QnaheaderWsBody | null>(null);

  qnaChatSubject = new BehaviorSubject<QnaheaderWsBody | null>(null);

  constructor(private authService: AuthService) {
    super();
    this.setLogoutEvent();
  }

  /**
   * QNA 구독
   * @param id 구독자 식별번호
   */
  subscribeQna(id: number): void {
    if (WsSubscriptionMap.has('qna')) {
      return;
    }

    const subscription = this.watch(`/topic/userInfo/qna/${id}`).subscribe(
      (message) => {
        try {
          this.qnaSubject.next(JSON.parse(message.body));
        } catch (error) {
          // do nothing
        }
      },
    );

    WsSubscriptionMap.set('qna', subscription);
  }

  /**
   * QNA 구독
   * @param id 구독자 식별번호
   */
  subscribeQnaChat(id: number, headerId: number): void {
    if (WsSubscriptionMap.has('qnaChat')) {
      return;
    }

    const subscription = this.watch(
      `/topic/userInfo/qna/${id}/${headerId}`,
    ).subscribe((message) => {
      try {
        this.qnaChatSubject.next(JSON.parse(message.body));
      } catch (error) {
        // do nothing
      }
    });

    WsSubscriptionMap.set('qnaChat', subscription);
  }

  /**
   * 전부 구독 해제
   */
  unsubcribeAll(): void {
    WsSubscriptionMap.forEach((subscription, key) => {
      this.unsubscribe(key);
    });
  }

  /**
   * 구독 해제
   * @param type 해제하려는 구독
   */
  unsubscribe(type: WsSubscriptionType): void {
    if (!WsSubscriptionMap.has(type)) {
      return;
    }

    WsSubscriptionMap.get(type)!.unsubscribe();
    WsSubscriptionMap.delete(type);
  }

  /**
   * 로그아웃 이벤트 설정
   */
  private setLogoutEvent(): void {
    this.authService.logoutSubject$
      .pipe(
        tap(() => {
          this.unsubcribeAll();
        }),
      )
      .subscribe();
  }
}
